export default __webpack_public_path__ + "static/IN-5905HD_Cable-Installation-73393b1235a4f01b9291e3bd264588ec.png";